import { PartialDeep } from 'type-fest';
import { Styles } from 'react-joyride';

export const AI_GENERATION_TOUR_DB_TABLE = 'aiGenerationTour';

export const AI_GENERATION_TOUR_HEADER_SCROLL_OFFSET = 72;
export const AI_GENERATION_TOUR_CARD_SCROLL_OFFSET = 112;
export const AI_GENERATION_TOUR_START_DELAY_MS = 400;

/** DOM hedefleri – Joyride adımları ve bileşen className'leri ile eşleşir */
export const AI_GENERATION_TOUR_TARGETS = {
    root: '.hanger-photo-upload-generate',
    addCard: '.tour-add-card',
    layoutToggle: '.tour-layout-toggle',
    history: '.tour-history',
    targetCard: '.tour-target-card',
    statusBar: '.tour-status-bar',
    duplicateWithPhotos: '.tour-duplicate-with-photos',
    duplicateCard: '.tour-duplicate-card',
    configSection: '.tour-config-section',
    promptEditor: '.tour-prompt-editor',
    photosGrid: '.tour-photos-grid',
    cardMenu: '.tour-card-menu',
    generateBtn: '.tour-generate-btn',
    generatedSection: '.tour-generated-section',
    helpBtn: '.tour-start-btn',
} as const;

export const AI_GENERATION_TOUR_JOYRIDE_STYLES: PartialDeep<Styles> = {
    options: {
        arrowColor: '#ffffff',
        backgroundColor: '#ffffff',
        overlayColor: 'rgba(15, 23, 42, 0.42)',
        primaryColor: '#1565c0',
        spotlightShadow: '0 0 0 3px rgba(21, 101, 192, 0.35)',
        textColor: '#334155',
        width: 400,
        zIndex: 10000,
    },
    overlay: {
        backgroundColor: 'rgba(15, 23, 42, 0.42)',
    },
    spotlight: {
        borderRadius: 12,
    },
    tooltip: {
        padding: 0,
        borderRadius: 16,
    },
};

export const AI_GENERATION_TOUR_FLOATER_PROPS = { offset: 14 };
